import axios from "axios";

const { host } = window.location;

let baseURL = "";

if (host.includes("localhost")) {
  baseURL = "http://localhost:1337";
} else if (host.includes("rfidams.hl1.in")) {
  baseURL = "https://rfidams.bk.hl1.in/";
}

export const authAPI = axios.create({
  baseURL,
});

export const Url = baseURL;
